var _path, _path2, _rect, _circle, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.509 2.61719H4.02225C2.08173 2.61719 0.508636 4.19029 0.508636 6.1308V22.9961C0.508636 24.9366 2.08173 26.5097 4.02225 26.5097H20.8876C22.8281 26.5097 24.4012 24.9366 24.4012 22.9961V14.5635",
    stroke: "black",
    strokeWidth: 1.01727,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8065 14.5651H20.8878C21.276 14.5651 21.5906 14.8797 21.5906 15.2678V18.139C21.5906 18.3253 21.5165 18.5041 21.3847 18.6359L16.526 23.4946C16.3942 23.6264 16.2155 23.7005 16.0291 23.7005H5.42796C4.26365 23.7005 3.31979 22.7566 3.31979 21.5923V7.53785C3.31979 6.37355 4.26365 5.42969 5.42796 5.42969H13.5093",
    stroke: "black",
    strokeWidth: 1.01727,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.99757,
    y: 12.1014,
    width: 4.91906,
    height: 4.91906,
    rx: 0.351361,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.702722
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0783,
    cy: 9.64804,
    r: 0.702722,
    fill: "#0A0B0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3756 6.12742C19.7042 6.12742 21.5919 8.01513 21.5919 10.3437",
    stroke: "black",
    strokeWidth: 1.01727,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3756 3.31653C21.2566 3.31653 24.4028 6.46272 24.4028 10.3437",
    stroke: "black",
    strokeWidth: 1.01727,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3756 0.505639C22.809 0.505639 27.2137 4.91031 27.2137 10.3437",
    stroke: "black",
    strokeWidth: 1.01727,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotIcon);
export default __webpack_public_path__ + "static/media/iotIcon.5bd63838de01a5bcd78f3dc65aec1a44.svg";
export { ForwardRef as ReactComponent };